import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, InputAdornment, MenuItem, TextField, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import LookupApp_old from 'app/Core/Components/Lookup_old/LookupApp_old';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import EmpresaFormaPagamentoApp from 'app/ERP/EmpresaFormaPagamento/EmpresaFormaPagamentoApp';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import React from "react";
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import EmpresaCategoriaApp from '../../EmpresaCategoria/EmpresaCategoriaApp';
import EmpresaCentroCustoApp from '../../EmpresaCentroCusto/EmpresaCentroCustoApp';
import EmpresaContaApp from '../../EmpresaConta/EmpresaContaApp';
import * as Actions from '../Store/Actions/EmpresaFinanceiroActions';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

const NewState = {
    idtarefaprocessoapontamentoitem: null,
    observacao: null,
    idpessoaformularioconta: null,
    idpessoaformulariocategoria: null,
    idpessoaformulariocentrocusto: null,
    vencimento: null,
    idpessoaformularioformapagamento: null,
    valorliquido: null,
    baixa: null,
    taxas: null,
};

class EmpresaFinanceiroTituloDialog extends XAPPComponent {

    state = { ...NewState };

    componentDidUpdate(prevProps) {
        if (this.props.EmpresaFinanceiro.error) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.error,
                variant: 'error'
            });
            this.props.EmpresaFinanceiro.error = null;
        }

        if (prevProps.open === null && this.props.open !== null) {
            var obj = { ...this.props.open };
            if (!_.isNull(obj.baixa)) {
                obj.baixa = obj.baixa.toString().split("T")[0];
            } if (_.isNull(obj.taxas)) {
                obj.taxas = 0;
            }
            this.setState(obj);
        }

        if (prevProps.open !== null && this.props.open === null) {
            this.setState(NewState);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    handleChangeFormaPagamento = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj["idpessoaformularioformapagamento"] = _AValue[0].idpessoaformulario;
            obj["idpessoaformularioformapagamentodescricao"] = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj["idpessoaformularioformapagamento"] = null;
            obj["idpessoaformularioformapagamentodescricao"] = null;
            this.setState(obj);
        }
    };

    canBeSubmitted = () => {
        const { vencimento, status, baixa, valorliquido, idpessoaformularioconta, idpessoaformularioformapagamento, idpessoaformulariocentrocusto } = this.state;
        switch (status) {
            case "baixado":
                return (
                    baixa !== null && baixa !== '' &&
                    valorliquido !== null && valorliquido !== '' &&
                    idpessoaformularioconta !== null && idpessoaformularioconta !== '' &&
                    vencimento !== null && vencimento !== '' &&
                    idpessoaformularioformapagamento !== null && idpessoaformularioformapagamento !== ''
                )
            default:
                return (
                    vencimento !== null && vencimento !== '' &&
                    idpessoaformularioformapagamento !== null && idpessoaformularioformapagamento !== ''
                )
        }
    }

    handleLookupEmpresaCentroCusto = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformulariocentrocusto = AItem.idpessoaformulario;
            obj.idpessoaformulariocentrocustodescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformulariocentrocusto = null;
            obj.idpessoaformulariocentrocustodescricao = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaCategoria = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformulariocategoria = AItem.idpessoaformulario;
            obj.idpessoaformulariocategoriadescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformulariocategoria = null;
            obj.idpessoaformulariocategoriadescricao = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaConta = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformularioconta = AItem.idpessoaformulario;
            obj.idpessoaformulariocontadescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformularioconta = null;
            obj.idpessoaformulariocontadescricao = null;
            this.setState(obj);
        }
    };

    render() {
        const { savePagarReceber, open, xappRouteParams, openDialog, filter, callback, parametros } = this.props;
        const form = this.state;
        const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', });
        return (
            <XAPPDialog
                id="FinanceiroTitulo"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                maxWidth="sm"
                fullScreen={md.mobile() !== null}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"Alterar titulo"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Typography color="textSecondary" className="text-16 my-8">{`Nome: ${form.nome}`}</Typography>
                    {form.status === "baixado" &&
                        <Typography color="textSecondary" className="text-16 my-8">{`Vencimento em: ${form.vencimentodescricao}`}</Typography>
                    }
                    <Typography color="textSecondary" className="text-16 my-8">{`Valor: ${formatter.format(form.valor)}`}</Typography>
                    <Typography color="textSecondary" className="text-16 my-8">{`Taxas: ${formatter.format(form.taxas)}`}</Typography>
                    {form.status === "baixado" &&
                        <Typography color="textSecondary" className="text-16 my-8">{`Valor liquido: ${formatter.format(form.valorliquido)}`}</Typography>
                    }
                    {form.status !== "baixado" &&
                        <TextField
                            className="mt-16"
                            id="vencimento"
                            name="vencimento"
                            label="Vencimento"
                            value={form.vencimento}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            required
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                    {form.status === "baixado" &&
                        <TextField
                            className="mt-16"
                            id="baixa"
                            name="baixa"
                            label="baixa"
                            value={form.baixa}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            required
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                    <EmpresaFormaPagamentoApp
                        className="mt-16"
                        xappRouteParams={xappRouteParams}
                        required={true}
                        isLookup={true}
                        multiSelect={false}
                        onChange={this.handleChangeFormaPagamento}
                        id="NovoFormaPagamento"
                        key="NovoFormaPagamento"
                        label="Forma de pagamento"
                        selected={!_.isNull(form.idpessoaformularioformapagamento) ? [{ idpessoaformulario: form.idpessoaformularioformapagamento, nome: form.idpessoaformularioformapagamentodescricao }] : []}
                        target="spvwempresaformapagamentolookup"
                        autoSearch={true}
                        selectFirstAuto={true}
                    />
                    <div className="mt-16 flex">
                        <EmpresaContaApp
                            className="mt-16"
                            xappRouteParams={this.props.xappRouteParams}
                            required={false}
                            isLookup={true}
                            multiSelect={false}
                            onChange={this.handleLookupEmpresaConta}
                            id="NovoConta"
                            key="NovoConta"
                            label="Conta"
                            selected={!_.isNull(form.idpessoaformularioconta) ? [{ idpessoaformulario: form.idpessoaformularioconta, nome: form.idpessoaformulariocontadescricao }] : []}
                            target="spvwempresacontalookup"
                            autoSearch={true}
                            selectFirstAuto={true}
                        />
                    </div>
                    <div className="mt-16 flex">
                        <EmpresaCategoriaApp
                            className="mt-16"
                            xappRouteParams={this.props.xappRouteParams}
                            required={false}
                            isLookup={true}
                            multiSelect={false}
                            onChange={this.handleLookupEmpresaCategoria}
                            id="NovoCategoria"
                            key="NovoCategoria"
                            label="Categoria"
                            selected={!_.isNull(form.idpessoaformulariocategoria) ? [{ idpessoaformulario: form.idpessoaformulariocategoria, nome: form.idpessoaformulariocategoriadescricao }] : []}
                            filter={{
                                AND: [
                                    { "Campo": "pessoaformulario.formulario->>''natureza''", "Operador": "=", "Valor": '2' },
                                    { "Campo": "pessoaformulario.formulario->>''tipocategoria''", "Operador": "=", "Valor": parametros.tipo === 1 ? '1' : '2' }
                                ]
                            }}
                            target="spvwempresacategorialookup"
                        />
                    </div>
                    <div className="mt-16 flex">
                        <EmpresaCentroCustoApp
                            className="mt-16"
                            xappRouteParams={this.props.xappRouteParams}
                            required={false}
                            isLookup={true}
                            multiSelect={false}
                            onChange={this.handleLookupEmpresaCentroCusto}
                            id="NovoCentroCusto"
                            key="NovoCentroCusto"
                            label="Centro de Custo"
                            selected={!_.isNull(form.idpessoaformulariocentrocusto) ? [{ idpessoaformulario: form.idpessoaformulariocentrocusto, nome: form.idpessoaformulariocentrocustodescricao }] : []}
                            target="spvwempresacentrocustolookup"
                        />
                    </div>
                    <TextField
                        className="mt-16"
                        id="observacao"
                        name="observacao"
                        label="Observações"
                        value={form.observacao}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                onClick={(ev) => {
                                    savePagarReceber("ALTERARTITULO", form, xappRouteParams, filter);
                                    if (callback !== undefined && callback !== null) {
                                        callback();
                                    }
                                    openDialog(null);
                                }}
                                disabled={!this.canBeSubmitted()}
                                variant="contained"
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={'save'}
                                label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                                key={"btnAlterarDadosTitulo"}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listPagarReceber: Actions.listPagarReceber,
        savePagarReceber: Actions.savePagarReceber,
        showMessage: AppActions.showMessage
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroTituloDialog)));
